document.addEventListener('DOMContentLoaded', () => {
  // V62: On some mobile browsers the initial #christmas-cross-sell jump can
  // happen before the page has finished settling, which leaves the visitor
  // one section too high. Re-align the anchor a few times while the layout
  // stabilizes, but stop immediately as soon as the visitor interacts.
  const keepChristmasAnchorAligned = () => {
    if(window.location.hash !== '#christmas-cross-sell') return;
    if(!window.matchMedia('(max-width: 749px)').matches) return;

    const target = document.getElementById('christmas-cross-sell');
    if(!target) return;

    let cancelled = false;
    const cancel = () => { cancelled = true; };
    ['touchstart','pointerdown','wheel','keydown'].forEach(type => {
      window.addEventListener(type, cancel, { once: true, passive: true });
    });

    const align = () => {
      if(cancelled || window.location.hash !== '#christmas-cross-sell') return;
      const top = target.getBoundingClientRect().top;
      // Only correct when the section has drifted noticeably away from the
      // expected anchor position. scroll-margin-top on the section handles
      // the sticky header spacing.
      if(Math.abs(top - 92) > 28){
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    };

    requestAnimationFrame(align);
    [180, 450, 900, 1500].forEach(delay => window.setTimeout(align, delay));
    window.addEventListener('load', align, { once: true });
    window.addEventListener('pageshow', align, { once: true });
  };

  keepChristmasAnchorAligned();
  const money = (v) => v || '';
  document.querySelectorAll('[data-ghost-product]').forEach(scope => {
    const radios = scope.querySelectorAll('[data-ghost-variant]');
    const hidden = scope.querySelector('input[name="id"]');
    const price = scope.querySelector('[data-price]');
    const compare = scope.querySelector('[data-compare]');
    const saving = scope.querySelector('[data-saving]');
    const button = scope.querySelector('[data-add-button]');
    const mobilePrice = document.querySelector('[data-mobile-price]');
    const mobileButton = document.querySelector('[data-mobile-submit]');
    const mobileSoloText = mobileButton ? (mobileButton.dataset.soloText || mobileButton.textContent) : '';
    const mobileSelection = document.querySelector('[data-mobile-selection]');
    const heroImage = scope.querySelector('[data-hero-image]');
    const seasonMedia = scope.querySelector('[data-season-media]');
    const seasonPair = scope.querySelector('[data-season-pair]');
    const selectedSetTotal = scope.querySelector('[data-selected-set-total]');
    const selectedSetName = scope.querySelector('[data-selected-set-name]');
    const addError = scope.querySelector('[data-add-error]');
    const stockAlert = scope.querySelector('[data-stock-alert]');
    const stockAlertText = scope.querySelector('[data-stock-alert-text]');
    const bundlePanel = scope.querySelector('[data-bundle-panel]');
    const bundleCards = bundlePanel ? Array.from(bundlePanel.querySelectorAll('[data-bundle-card]')) : [];
    const bundleInputs = bundlePanel ? Array.from(bundlePanel.querySelectorAll('[data-bundle-option]')) : [];
    const bundleQuantity = scope.querySelector('[data-bundle-quantity]');
    const storeLocale = scope.dataset.storeLocale || document.documentElement.lang || 'nl';
    const storeCurrency = scope.dataset.storeCurrency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const optionInputs = Array.from(scope.querySelectorAll('[data-product-option-value]'));
    const variantRadios = Array.from(radios);
    let isSubmitting = false;
    let lockedControls = [];

    const radioOptions = (radio) => {
      if(!radio) return [];
      try { return JSON.parse(radio.dataset.optionValues || '[]'); }
      catch(error) { return []; }
    };

    const selectedOptionValues = () => {
      const groups = Array.from(scope.querySelectorAll('[data-product-option-group]'))
        .sort((a, b) => Number(a.dataset.optionIndex || 0) - Number(b.dataset.optionIndex || 0));
      return groups.map(group => {
        const selected = group.querySelector('[data-product-option-value]:checked');
        return selected ? selected.value : '';
      });
    };

    const findVariantForOptions = (values) => variantRadios.find(radio => {
      const options = radioOptions(radio);
      return options.length === values.length && options.every((value, index) => value === values[index]);
    });

    const syncOptionInputsFromRadio = (radio) => {
      const values = radioOptions(radio);
      values.forEach((value, index) => {
        const group = scope.querySelector(`[data-product-option-group][data-option-index="${index}"]`);
        if(!group) return;
        const input = Array.from(group.querySelectorAll('[data-product-option-value]')).find(item => item.value === value);
        if(input) input.checked = true;
      });
    };

    const localeMap = { nl: 'nl-NL', de: 'de-DE', en: 'en-GB' };
    const moneyFormatter = new Intl.NumberFormat(localeMap[storeLocale] || storeLocale, { style: 'currency', currency: storeCurrency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const formatCents = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);
    const savingFormatter = new Intl.NumberFormat(localeMap[storeLocale] || storeLocale, { style: 'currency', currency: storeCurrency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const formatSaving = (cents) => cents > 0 && cents < 100 ? formatCents(cents) : savingFormatter.format(Math.round(cents / 100));
    const cardQuantity = card => Math.max(1, Math.floor(Number(card ? card.dataset.bundleQty : 1) || 1));
    const selectedBundleCard = () => {
      const input = bundleInputs.find(item => item.checked && !item.disabled);
      return input ? input.closest('[data-bundle-card]') : null;
    };
    const isChristmasCard = card => !!card && card.dataset.bundleKind === 'christmas';
    const extraPrice = card => isChristmasCard(card) ? Number(card.dataset.bundleAddonPriceCents || 0) : 0;

    function syncPurchaseButtons(radio, card){
      const available = !!radio && radio.dataset.available === 'true' && (!bundlePanel || !!card);
      const combo = isChristmasCard(card);
      if(button){
        button.disabled = isSubmitting || !available;
        button.textContent = isSubmitting ? button.dataset.loadingText : (!available ? button.dataset.soldoutText : (combo && button.dataset.comboText ? button.dataset.comboText : button.dataset.availableText));
      }
      if(mobileButton){
        mobileButton.disabled = isSubmitting || !available;
        mobileButton.textContent = isSubmitting ? (mobileButton.dataset.loadingText || (button && button.dataset.loadingText) || mobileSoloText) : (!available ? ((button && button.dataset.soldoutText) || mobileSoloText) : (combo && mobileButton.dataset.comboText ? mobileButton.dataset.comboText : mobileSoloText));
      }
    }

    function syncBundlePrices(radio){
      if(!bundlePanel || !radio) return;
      const priceCents = Number(radio.dataset.priceCents || 0);
      const compareCents = Number(radio.dataset.compareCents || priceCents);
      const inventoryManaged = !!radio.dataset.inventoryManagement;
      const inventoryPolicy = radio.dataset.inventoryPolicy || 'deny';
      const inventoryQty = Number(radio.dataset.inventoryQuantity || 0);

      bundleCards.forEach(card => {
        const qty = cardQuantity(card);
        const combo = isChristmasCard(card);
        const discountCents = Number(card.dataset.bundleDiscountCents || 0);
        const addonCents = extraPrice(card);
        const regularTotal = priceCents * qty + addonCents;
        const total = Math.max(0, regularTotal - discountCents);
        const each = Math.round(total / (qty + (combo ? 1 : 0)));
        const addonCompare = combo ? Math.max(addonCents, Number(card.dataset.bundleAddonCompareCents || addonCents)) : 0;
        const compareTotal = Math.max(compareCents, priceCents) * qty + addonCompare;
        const totalSaving = Math.max(0, compareTotal - total);
        const totalEl = card.querySelector('[data-bundle-total]');
        const eachEl = card.querySelector('[data-bundle-each]');
        const regularEl = card.querySelector('[data-bundle-regular]');
        const savingEl = card.querySelector('[data-bundle-total-saving]');
        if(totalEl) totalEl.textContent = formatCents(total);
        if(eachEl) eachEl.textContent = formatCents(each);
        if(regularEl) regularEl.textContent = formatCents(regularTotal);
        if(savingEl) savingEl.textContent = formatSaving(totalSaving);

        const input = card.querySelector('[data-bundle-option]');
        const extraUnavailable = combo && (!Number(card.dataset.bundleAddonId) || card.dataset.bundleAddonAvailable !== 'true');
        const insufficient = radio.dataset.available !== 'true' || extraUnavailable || (inventoryManaged && inventoryPolicy !== 'continue' && inventoryQty < qty);
        if(input) input.disabled = insufficient;
        card.classList.toggle('is-disabled', insufficient);
      });

      if(!bundleInputs.some(input => input.checked && !input.disabled)){
        const fallback = bundleInputs.find(input => !input.disabled);
        bundleInputs.forEach(input => { input.checked = input === fallback; });
      }
      syncBundleSelection(radio);
    }

    function syncBundleSelection(radio){
      const card = selectedBundleCard();
      const qty = cardQuantity(card);
      const combo = isChristmasCard(card);
      bundleCards.forEach(item => item.classList.toggle('is-selected', item === card));
      if(bundleQuantity) bundleQuantity.value = String(qty);
      const showPairGallery = combo && card.dataset.bundleGallery !== 'solo';
      if(seasonMedia) seasonMedia.classList.toggle('is-combo', showPairGallery);
      if(seasonPair) seasonPair.hidden = !showPairGallery;
      [selectedSetName, mobileSelection].forEach(label => {
        if(label) label.textContent = (combo ? (card.dataset.bundleLabel || label.dataset.comboText) : label.dataset.soloText) || '';
      });
      if(radio){
        const priceCents = Number(radio.dataset.priceCents || 0);
        const discountCents = card ? Number(card.dataset.bundleDiscountCents || 0) : 0;
        const total = formatCents(Math.max(0, priceCents * qty + extraPrice(card) - discountCents));
        if(mobilePrice) mobilePrice.textContent = total;
        if(selectedSetTotal) selectedSetTotal.textContent = total;
      }
      syncPurchaseButtons(radio, card);
    }

    bundleInputs.forEach(input => input.addEventListener('change', () => {
      if(isSubmitting) return;
      if(addError) addError.hidden = true;
      syncBundleSelection(scope.querySelector('[data-ghost-variant]:checked'));
    }));

    const restorePurchaseControls = () => {
      lockedControls.forEach(([control, wasDisabled]) => { control.disabled = wasDisabled; });
      lockedControls = [];
      isSubmitting = false;
      const radio = scope.querySelector('[data-ghost-variant]:checked');
      if(bundlePanel) syncBundlePrices(radio);
      else syncPurchaseButtons(radio, null);
    };

    const productForm = scope.querySelector('#GhostProductForm');
    if(productForm){
      productForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        if(isSubmitting || !hidden || !hidden.value || !button || button.disabled) return;
        const card = selectedBundleCard();
        if(bundlePanel && !card) return;
        const items = [{ id: Number(hidden.value), quantity: cardQuantity(card) }];
        if(isChristmasCard(card)){
          const addonId = Number(card.dataset.bundleAddonId || 0);
          if(!addonId || card.dataset.bundleAddonAvailable !== 'true') return;
          items.push({ id: addonId, quantity: 1 });
        }
        const selectedAddons = Array.from(scope.querySelectorAll('[data-addon-checkbox]:checked:not(:disabled)'));
        if(addError) addError.hidden = true;
        isSubmitting = true;
        syncPurchaseButtons(scope.querySelector('[data-ghost-variant]:checked'), card);
        lockedControls = Array.from(scope.querySelectorAll('[data-product-option-value], [data-ghost-variant], [data-bundle-option], [data-addon-checkbox]')).map(control => [control, control.disabled]);
        lockedControls.forEach(([control]) => { control.disabled = true; });
        try {
          // Extras are promised once per order, including when another variant
          // is added later. Read the current cart before adding selected extras.
          if(selectedAddons.length){
            const cartResponse = await fetch(`${scope.dataset.cartUrl || '/cart'}.js`, {
              headers: { 'Accept': 'application/json' }, cache: 'no-store'
            });
            if(!cartResponse.ok) throw new Error('cart read failed');
            const currentCart = await cartResponse.json();
            if(!Array.isArray(currentCart.items)) throw new Error('invalid cart');
            const existingIds = new Set(currentCart.items.filter(item => item.quantity > 0).map(item => Number(item.variant_id || item.id)));
            items.forEach(item => existingIds.add(item.id));
            selectedAddons.forEach(addon => {
              const addonId = Number(addon.dataset.addonId || 0);
              if(!addonId || existingIds.has(addonId)) return;
              items.push({ id: addonId, quantity: 1, properties: { '_yafico_addon_type': addon.dataset.addonType || 'addon' } });
              existingIds.add(addonId);
            });
          }
          // A single request adds exactly the chosen Halloween variant and, for
          // the seasonal set, one Christmas scene. Shopify applies its discount.
          const response = await fetch(scope.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if(!response.ok) throw new Error('cart add failed');
          window.location.href = scope.dataset.cartUrl || '/cart';
        } catch(error) {
          restorePurchaseControls();
          if(addError){
            addError.textContent = button.dataset.errorText || '';
            addError.hidden = false;
          } else {
            const restoredText = button.textContent;
            button.textContent = button.dataset.errorText || restoredText;
            window.setTimeout(() => { if(!isSubmitting) syncPurchaseButtons(scope.querySelector('[data-ghost-variant]:checked'), selectedBundleCard()); }, 2200);
          }
        }
      });
    }

    function sync(radio, updateUrl){
      if(!radio || isSubmitting) return;
      if(hidden) hidden.value = radio.value;
      if(price) price.textContent = money(radio.dataset.price);
      if(compare){
        compare.textContent = money(radio.dataset.compare);
        compare.hidden = !radio.dataset.compare;
      }
      if(saving){
        saving.textContent = radio.dataset.saving || '';
        saving.hidden = !radio.dataset.saving;
      }
      if(addError) addError.hidden = true;
      if(radio.dataset.heroImage){
        const nextSrc = radio.dataset.heroImage;
        const nextSrcset = radio.dataset.heroSrcset || '';
        [heroImage, ...scope.querySelectorAll('[data-season-ghost-thumb]')].forEach(image => {
          if(!image) return;
          // Avoid resetting an already-loaded image during the initial sync.
          if(image.getAttribute('src') !== nextSrc) image.setAttribute('src', nextSrc);
          if(nextSrcset && image.getAttribute('srcset') !== nextSrcset) image.setAttribute('srcset', nextSrcset);
        });
      }
      if(stockAlert && stockAlertText){
        const stockText = radio.dataset.stockText || '';
        stockAlertText.textContent = stockText;
        stockAlert.hidden = !stockText;
      }
      if(bundlePanel) syncBundlePrices(radio);
      else syncBundleSelection(radio);
      if(updateUrl && location.pathname.includes('/products/')){
        const url = new URL(location.href);
        url.searchParams.set('variant', radio.value);
        history.replaceState({}, '', url);
      }
    }

    optionInputs.forEach(input => input.addEventListener('change', () => {
      if(isSubmitting) return;
      const values = selectedOptionValues();
      const radio = findVariantForOptions(values);
      if(radio){
        radio.checked = true;
        sync(radio, true);
      }
    }));
    radios.forEach(radio => radio.addEventListener('change', () => {
      if(isSubmitting) return;
      syncOptionInputsFromRadio(radio);
      sync(radio, true);
    }));
    const initialRadio = scope.querySelector('[data-ghost-variant]:checked') || variantRadios[0];
    if(initialRadio){
      syncOptionInputsFromRadio(initialRadio);
      sync(initialRadio, false);
    }
    if(bundlePanel) bundlePanel.dataset.bundleReady = 'true';
    scope.querySelectorAll('[data-season-picker]').forEach(picker => { picker.hidden = false; });
    window.addEventListener('pageshow', event => {
      if(event.persisted && isSubmitting) restorePurchaseControls();
    });
  });
  // V59: lightweight Christmas cross-sell. Adds the configured Christmas product and opens the cart,
  // where Shopify applies the existing bundle discount rules.
  document.querySelectorAll('[data-christmas-add]').forEach(button => {
    button.addEventListener('click', async () => {
      const variantId = Number(button.dataset.christmasVariantId || 0);
      if(!variantId || button.disabled) return;
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = button.dataset.loadingText || originalText;
      try {
        const response = await fetch(button.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if(!response.ok) throw new Error('christmas add failed');
        window.location.href = button.dataset.cartUrl || '/cart';
      } catch(error) {
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  });

  const mobileBtn = document.querySelector('[data-mobile-submit]');
  if(mobileBtn){
    mobileBtn.addEventListener('click', () => {
      const btn = document.querySelector('[data-add-button]');
      if(btn) btn.click();
    });
  }

  // V33: keep video/poster completely out of the critical loading path.
  // The observer itself is non-critical, so install it when the browser is idle.
  const initLazyVideos = () => {
    const lazyVideos = Array.from(document.querySelectorAll('[data-lazy-video]'));
    if(!lazyVideos.length) return;

    const loadVideo = (video) => {
      if(!video || video.dataset.loaded === 'true') return;
      if(video.dataset.poster && !video.getAttribute('poster')){
        video.setAttribute('poster', video.dataset.poster);
      }
      video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.loaded = 'true';
      video.load();
      const playPromise = video.play();
      if(playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    };

    if('IntersectionObserver' in window){
      const videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if(entry.isIntersecting){
            loadVideo(entry.target);
            videoObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '500px 0px' });
      lazyVideos.forEach(video => videoObserver.observe(video));
    } else {
      lazyVideos.forEach(loadVideo);
    }
  };

  if('requestIdleCallback' in window){
    requestIdleCallback(initLazyVideos, { timeout: 1200 });
  } else {
    setTimeout(initLazyVideos, 0);
  }

  // V40: customer videos load only after an explicit tap/click.
  document.querySelectorAll('[data-customer-video-shell]').forEach(shell => {
    const video = shell.querySelector('[data-customer-video]');
    const button = shell.querySelector('[data-customer-video-play]');
    if(!video || !button) return;

    const ensureLoaded = () => {
      if(video.dataset.loaded === 'true') return;
      video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.loaded = 'true';
      video.load();
    };

    const playVideo = () => {
      ensureLoaded();
      const promise = video.play();
      if(promise && typeof promise.catch === 'function') promise.catch(() => {});
    };

    button.addEventListener('click', playVideo);
    video.addEventListener('click', () => {
      if(video.paused) playVideo();
      else video.pause();
    });
    video.addEventListener('play', () => shell.classList.add('is-playing'));
    video.addEventListener('pause', () => shell.classList.remove('is-playing'));
    video.addEventListener('ended', () => shell.classList.remove('is-playing'));
  });

  document.querySelectorAll('[data-select-product-option-index]').forEach(el => el.addEventListener('click', e => {
    const optionIndex = Number(el.getAttribute('data-select-product-option-index'));
    const optionValue = el.getAttribute('data-select-product-option-value') || '';
    const scope = document.querySelector('[data-ghost-product]');
    const target = document.querySelector('#buy');
    if(!scope) return;
    const input = Array.from(scope.querySelectorAll(`[data-product-option-value][data-option-index="${optionIndex}"]`)).find(item => item.value === optionValue);
    if(input){
      e.preventDefault();
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if(target){ target.scrollIntoView({behavior:'smooth', block:'center'}); }
    }
  }));

  // Backwards compatibility for older links that targeted a specific variant index.
  document.querySelectorAll('[data-select-variant-index]').forEach(el => el.addEventListener('click', e => {
    const index = Number(el.getAttribute('data-select-variant-index'));
    const target = document.querySelector('#buy');
    const radios = document.querySelectorAll('[data-ghost-product] [data-ghost-variant]');
    const radio = radios[index];
    if(radio){
      e.preventDefault();
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      if(target){ target.scrollIntoView({behavior:'smooth', block:'center'}); }
    }
  }));
});
